/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ main: NonNullable<unknown>, foreign: NonNullable<unknown> }} Snackbar_Mappingassignederror2Inputs */

const en_snackbar_mappingassignederror2 = /** @type {(inputs: Snackbar_Mappingassignederror2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to assign ${i?.main} to ${i?.foreign}.`)
};

const de_snackbar_mappingassignederror2 = /** @type {(inputs: Snackbar_Mappingassignederror2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Zuordnen von ${i?.main} zu ${i?.foreign}.`)
};

/**
* | output |
* | --- |
* | "Failed to assign {main} to {foreign}." |
*
* @param {Snackbar_Mappingassignederror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const snackbar_mappingassignederror2 = /** @type {((inputs: Snackbar_Mappingassignederror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snackbar_Mappingassignederror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_snackbar_mappingassignederror2(inputs)
	return de_snackbar_mappingassignederror2(inputs)
});
export { snackbar_mappingassignederror2 as "snackbar_mappingAssignedError" }